import { MagicConfigMixin } from '@gig/magic-common';
import { LoyaltyExchange } from '../../../components/loyalty/loyalty-exchange';
import { Shop } from '@gig/magic-gamification';
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import { GameList } from '@gig/magic-gameplay';


@Component({
    components: {
        LoyaltyExchange,
        Shop,
        GameList,
    },
})
export default class LoyaltyExchangePage extends Mixins(MagicConfigMixin) {}
